import { useEffect } from "react";
import { useClientStore } from "../store";

export function useTheme() {
  const { theme, toggleTheme } = useClientStore();

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    localStorage.setItem("theme", theme);
  }, [theme]);

  return { theme, toggleTheme };
}
